import * as React from "react";
import { useCurrentRefinements, useClearRefinements, useStats } from "react-instantsearch";
import { DataLayer } from "@grandvisionhq/analytics";
import { useIntl } from "@grandvisionhq/state";
import { useItemsToClear } from "../../../../../hooks/Algolia/hooks/use-items-to-clear.js";
import { ClearFacetFilter } from "../../../../ClearFacetFilter/Algolia/components/ClearFacetFilter/ClearFacetFilter.js";
import { ConnectedFacetsContainer } from "../../../components/ConnectedFacetsContainer/Algolia/components/FacetsMobile/components/ConnectedFacetsContainer/ConnectedFacetsContainer.js";
import { FacetsDrawer } from "../../../components/FacetsDrawer/Algolia/components/FacetsMobile/components/FacetsDrawer/FacetsDrawer.js";
import { FacetsDrawerFooter } from "../../../components/FacetsDrawerFooter/Algolia/components/FacetsMobile/components/FacetsDrawerFooter/FacetsDrawerFooter.js";
import { FacetsMobileTrigger } from "../../../components/FacetsMobileTrigger/Algolia/components/FacetsMobile/components/FacetsMobileTrigger/FacetsMobileTrigger.js";
const FacetsMobile = ({ facets, isSearchPage }) => {
  const { items } = useCurrentRefinements();
  const excludedAttributes = React.useMemo(
    () => isSearchPage ? ["query"] : ["filterableAttributes.productType", "productType"],
    [isSearchPage]
  );
  const { refine: clearRefine } = useClearRefinements({
    excludedAttributes
  });
  const { nbHits } = useStats();
  const { getLabel } = useIntl();
  const [touched, setTouched] = React.useState(false);
  const [scrollIntoView, setScrollIntoView] = React.useState(false);
  const filterButton = React.useRef(null);
  const itemsToClear = useItemsToClear(items);
  const activeFilterCount = itemsToClear.reduce((prev, curr) => {
    const itemCount = curr.refinements && curr.refinements.length || 1;
    return prev + itemCount;
  }, 0);
  const handleOpen = React.useCallback(() => {
    setTouched(false);
    DataLayer.Events.pushDrawerEventToDataLayer({
      siteFeature: "product_list_page",
      interactionType: "filter_button_on_mobile_click"
    });
  }, [setTouched]);
  const handleClear = React.useCallback(() => {
    setTouched(true);
    clearRefine();
    DataLayer.Events.pushDrawerFilterEventToDataLayer({
      siteFeature: "product_list_page",
      interactionType: "filter_clear_all_click"
    });
  }, [clearRefine, setTouched]);
  const handleChange = React.useCallback(() => {
    setTouched(true);
  }, [setTouched]);
  const handleClose = React.useCallback(() => {
    if (touched) {
      setScrollIntoView(true);
    }
    setTouched(false);
    DataLayer.Events.pushDrawerFilterEventToDataLayer({
      siteFeature: "product_list_page",
      interactionType: "filter_close_click"
    });
  }, [setTouched, touched]);
  React.useEffect(() => {
    if (scrollIntoView) {
      filterButton?.current?.scrollIntoView(false);
      setScrollIntoView(false);
    }
  }, [scrollIntoView]);
  return /* @__PURE__ */ React.createElement(
    FacetsDrawer,
    {
      title: `${getLabel("products.filters")} (${activeFilterCount})`,
      ctaButton: /* @__PURE__ */ React.createElement(
        FacetsMobileTrigger,
        {
          onClick: handleOpen,
          caption: `${getLabel("search.filter")} ${activeFilterCount > 0 ? `(${activeFilterCount})` : ""}`,
          ref: filterButton
        }
      ),
      clearFacetsButton: /* @__PURE__ */ React.createElement(
        ClearFacetFilter,
        {
          label: getLabel("search.filters.clearAll"),
          onClear: handleClear,
          isDisabled: !itemsToClear.length
        }
      ),
      footerButton: /* @__PURE__ */ React.createElement(FacetsDrawerFooter, { activeFilterCount, totalNumberOfHits: nbHits }),
      onClose: handleClose
    },
    /* @__PURE__ */ React.createElement(ConnectedFacetsContainer, { facets, onChange: handleChange })
  );
};
export {
  FacetsMobile,
  FacetsMobile as default
};
//# sourceMappingURL=FacetsMobile.js.map
